import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { CellClickedEvent, ColDef, GridReadyEvent, GridSizeChangedEvent } from 'ag-grid-community';


@Component({
    selector: 'app-kpis-child',
    templateUrl: './kpis.component.html',
    styleUrls: ['./kpis.component.scss']
})
export class ChildKPIsComponent implements OnInit {
    @Input() kpi: any;
    @Input() id: any;
    @Input() dbData: any;
    @Input() hasMeteredBilling: any;
    gridClass = 'ag-theme-alpine-dark';

    labelArray: string[] = [];
    valuesArray: number[] = [];
    alertLabelsArray: string[] = [];
    alertValuesArray: number[] = [];
    activeTanksLabelsArray: string[] = [];
    activeTanksValuesArray: number[] = [];
    unitsLabelsArray: string[] = [];
    unitsValuesArray: number[] = [];
    kpiName: string | undefined;
    kpiValue: number | undefined;
    newAlertsTotal: number = 0;
    activeTanksTotal: number = 0;
    unitsInstalledTotal: number = 0;
    avgTankLevelTotal: number = 0;
    currentInventoryTotal: number = 0;
    availableStorageTotal: number = 0;
    silentUnitsTotal: number = 0;
    silentUnitsData: { id: number, esn: string, date: string }[] = [];
    watchlistTotal: number = 0;
    watchlistData: { id: number, name: string, status: string, lastMessage: string }[] = [];

    public defaultColDef: ColDef = {
        sortable: false,
        filter: false,
    };


    watchlistColDefs: ColDef[] = [
        { field: 'name', sortable: false, filter: false, tooltipField: "Customer", headerName: "Customer" },
        { field: 'status', sortable: false, filter: false, tooltipField: "Status", headerName: "Status" },
        { field: 'lastMessage', sortable: false, filter: false, tooltipField: "Last Message", headerName: "Last Message", initialSort: 'asc' }
    ];

    silentUnitsColDefs: ColDef[] = [
        { field: 'esn', sortable: false, filter: false, tooltipField: "ESN", headerName: "ESN" },
        { field: 'date', sortable: false, filter: false, tooltipField: "Last Message", headerName: "Last Message" }
    ];

    constructor(private cdref: ChangeDetectorRef,
        private _router: Router,) { }

    ngOnInit() {
        if (localStorage.getItem('theme') == "light") {
            this.gridClass = 'ag-theme-alpine';
          } else {
            this.gridClass = 'ag-theme-alpine-dark';
          }
    }
    ngAfterViewInit() {
        for (let i = 0; i < this.dbData.length; i++) {
            this.kpiName = this.dbData[i].name;
            this.kpiValue = Math.round(this.dbData[i].total);
            if (this.dbData[i].type == 'bar' || this.dbData[i].type == 'doughnut') {
                this.processChartData(i);
            } else if (this.dbData[i].type == 'none' && this.dbData[i].name == 'Average Tank Level') {
                this.avgTankLevelTotal = this.dbData[i].total;
            } else if (this.dbData[i].type == 'none' && this.dbData[i].name == 'Tank Stats') {
                let valueSplit = this.dbData[i].value.split(', ');
                this.avgTankLevelTotal = Math.round(valueSplit[0]);
                this.currentInventoryTotal = Math.round(valueSplit[1]);
                this.availableStorageTotal = Math.round(valueSplit[2]);
            } else if (this.dbData[i].type == 'grid') {
                this.processGridData(i);
            }
        }
        this.cdref.detectChanges();
    }

    onGridReady(params: GridReadyEvent) {
        params.api.sizeColumnsToFit();
        params.api.resetRowHeights();
        params.api.setDomLayout('autoHeight');
    }

    onGridSizeChanged(params: GridSizeChangedEvent) {
        params.api.sizeColumnsToFit();
    }

    onCellClicked($event: CellClickedEvent) {
        let url: string = "/dashboard/tanks/tank/" + $event.data.id
        this._router.navigate([url]);
    }

    onSilentUnitCellClicked($event: CellClickedEvent) {
        let url: string = "/dashboard/units/unit/" + $event.data.id
        this._router.navigate([url]);
    }

    processGridData(index: number) {
        if (this.dbData[index].name.indexOf('Watchlist Tanks') > -1) {
            this.watchlistTotal = this.dbData[index].total;
            if (this.watchlistTotal > 0) {
                let valueSplit = this.dbData[index].value.split(' | ');
                for (let i = 0; i < valueSplit.length; i++) {
                    if (valueSplit[i].length > 1) {
                        let dataSplit = valueSplit[i].split(':');
                        let gridDataSplit = dataSplit[1].split(', ');
                        this.watchlistData.push({ 'id': dataSplit[0], 'name': gridDataSplit[0].trim(), 'status': gridDataSplit[1].replace(/([a-z](?=[A-Z]))/g, '$1 ').trim(), 'lastMessage': gridDataSplit[2] });
                    }
                }
            }
        }

        if (this.dbData[index].name.indexOf('Silent Units') > -1) {
            this.silentUnitsTotal = this.dbData[index].total;
            if (this.silentUnitsTotal > 0)
            {
                let valueSplit = this.dbData[index].value.split(' | ');
                for (let i = 0; i < valueSplit.length; i++) {
                    if (valueSplit[i].length > 1) {
                        let dataSplit = valueSplit[i].split(':');
                        let gridDataSplit = dataSplit[1].split(', ');
                        this.silentUnitsData.push({ 'id': dataSplit[0], 'esn': gridDataSplit[0], 'date': gridDataSplit[1] });
                    }
                }
            }
        }
    }

    processChartData(index: number) {
        let valueSplit = this.dbData[index].value != undefined ? this.dbData[index].value.split(' | ') : "";
        if (this.dbData[index].type == 'doughnut' && this.dbData[index].name.indexOf('Active Tanks') > -1) {
            this.activeTanksTotal = this.dbData[index].total;
            for (let i = 0; i < valueSplit.length; i++) {
                let dataSplit = valueSplit[i].split(':');
                this.activeTanksLabelsArray.push(dataSplit[0]);
                this.activeTanksValuesArray.push(dataSplit[1]);
            }
        }
        if (this.dbData[index].type == 'doughnut' && this.dbData[index].name.indexOf('SkyTracker') > -1) {
            this.unitsInstalledTotal = this.dbData[index].total;
            for (let i = 0; i < valueSplit.length; i++) {
                let dataSplit = valueSplit[i].split(':');
                this.unitsLabelsArray.push(dataSplit[0]);
                this.unitsValuesArray.push(dataSplit[1]);
            }
        }
        if (this.dbData[index].type == 'bar' && this.dbData[index].name.indexOf('Alerts') > -1) {
            this.newAlertsTotal = this.dbData[index].total != undefined ? this.dbData[index].total : 0;
            for (let i = 0; i < valueSplit.length; i++) {
                let dataSplit = valueSplit[i].split(':');
                this.alertLabelsArray.push(dataSplit[0].replace(/([a-z](?=[A-Z]))/g, '$1 '));
                this.alertValuesArray.push(dataSplit[1]);
            }
        }
    }

}